import React from 'react'
import { FlexColumn, FlexRow } from 'components/common/Containers'
import { H6 } from 'components/common/Texts/H6/H6'
import Image from 'next/image'
import styles from './LandingItem.module.scss'
import classNames from 'classnames'

interface Props {
  title: string
  description: string
  benefits: string[]
  imgSrc: string
  layout: 'imgLeft' | 'imgRight'
}

const LandingItem: React.FC<Props> = ({
  title,
  description,
  benefits,
  imgSrc,
  layout,
}) => {
  return (
    <FlexRow
      className={classNames(
        styles.wrapper,
        layout === 'imgLeft' && styles.reverse
      )}
      gap="20px"
      justify="space-between"
      align="center"
    >
      <div className={styles.info}>
        <FlexColumn align="normal" gap="32px">
          <H6 className={styles.title}>{title}</H6>

          <FlexColumn gap="20px">
            <p>{description}</p>

            <ul>
              {benefits.map((el, i) => (
                <li key={i}>{el}</li>
              ))}
            </ul>
          </FlexColumn>
        </FlexColumn>
      </div>

      <div className={styles.imgWrapper}>
        <Image src={imgSrc} alt={title} layout="fill" />
      </div>
    </FlexRow>
  )
}

export default LandingItem
